var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './QuickTable.css';
import QuickTableRow from './Support/QuickTableRow/QuickTableRow';
export default function QuickTable(_a) {
    var data = _a.data, headers = _a.headers, primaryKey = _a.primaryKey, _b = _a.defaultWidth, defaultWidth = _b === void 0 ? 100 : _b, headerStyle = _a.headerStyle, _c = _a.cellStyle, cellStyle = _c === void 0 ? function () { return ({}); } : _c, _d = _a.rowStyle, rowStyle = _d === void 0 ? function () { return ({}); } : _d, className = _a.className, rowClassName = _a.rowClassName, hover = _a.hover;
    var hoverClass = hover ? ' hover ' : '';
    return (_jsxs("div", __assign({ className: 'QuickTable ' + className }, { children: [_jsx("div", __assign({ className: "tableHeaders" }, { children: Object.keys(headers).map(function (h) {
                    var wd = headers[h].width || defaultWidth;
                    return _jsx("span", __assign({ style: __assign(__assign(__assign({}, headerStyle), headers[h].headerStyle), { width: wd }), className: "cellContainer headerCell" }, { children: _jsx("span", __assign({ className: "cell" }, { children: headers[h].title }), void 0) }), h);
                }) }), void 0), _jsx("div", __assign({ className: "tableBody" }, { children: data.map(function (r, idx) {
                    return _jsx(QuickTableRow, { index: idx, className: rowClassName + hoverClass, cellStyle: cellStyle, headers: headers, row: r, defaultWidth: defaultWidth, rowStyle: rowStyle }, r[primaryKey]);
                }) }), void 0)] }), void 0));
}
//# sourceMappingURL=QuickTable.js.map